import { createContext } from "react";
import { Apartment } from "../types";

const ApartmentContext = createContext<Apartment | null>(null);

export default ApartmentContext;
